import React, { createContext, useReducer } from "react";
const initialState = {
  user: null,
  isFirstLogin: false,
  isAuthticated: false,
};
const globalReducer = (state, action) => {
  switch (action.type) {
    case "SET_USER":
      return {
        ...state,
        user: action.payload,
      };
    case "SET_IS_FIRST_LOGIN":
      return {
        ...state,
        isFirstLogin: action.payload,
      };
    case "SET_IS_AUTHENTICATED":
      return {
        ...state,
        isAuthticated: action.payload,
      };
    case "RESET_STATE":
      return initialState;
    default:
      return state;
  }
};
export const GlobalContext = createContext();
const GlobalContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(globalReducer, initialState);
  const value = { state, dispatch };
  return (
    <GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>
  );
};

export default GlobalContextProvider;
